import angular from 'angular'
import {format as dateFormatter} from 'date-fns'

import countryDateFormat from "../country_date_format/filter";

// Used by both angular and date-fns for formatting
const countryDateTimeFormat = (parameters) => {
    let dateFormat;
    if (parameters?.countryCode) {
        dateFormat = countryDateFormat(parameters.countryCode, {useLongDateFormat: parameters.useLongDateFormat})
        if (dateFormat && parameters.includeDay) {
            dateFormat = "EEE, " + dateFormat;
        }
        if (dateFormat && parameters.includeTime) {
            dateFormat = dateFormat + " h:mma";
        }
    }

    return dateFormat;
};

const angularDefaultFormat = 'MMM d, y';
export const countryDate = (date, parameters) => {
    if (typeof date === 'string') {
        const dateNumber = Number(date)
        if (dateNumber > 0) {
            date = new Date(dateNumber)
        }
    }
    if (typeof date === 'number' && date > 0) {
        date = new Date(date)
    }
    if (!(date instanceof Date)) {
        return date
    }

    const format = (countryDateTimeFormat(parameters) || angularDefaultFormat)
    return dateFormatter(date, format)
}
export default countryDate

// format a date expression that's comparable with the AngularJS
// date filter into a string suitable for the given country code
// e.g. 1509498400780 might become "01/11/2017" for AU
// parameter: countryCode (required)
//     supply one of the valid country codes from the country filter
// parameter: includeTime (optional)
//     can opt in to include the time in the formatted date
// parameter: includeDay (optional)
//     can opt in to include the day in the formatted date
//     e.g. 1488632400000 might become "Sun, 03/05/2017" for AU
// parameter: useLongDateFormat (optional)
//     can opt in to use a long formatted version of the date
//     e.g. 1509498400780 might become "29 November, 2017" for AU
angular.module("core.application.main")
    .filter("core_application_main_filter_country_date", () => countryDate);
